<template>
    <nav v-click-outside="toggle">
        <div class="mobile">
            <a href="#" @click.stop.prevent="toggle" class="fa fa-bars" v-if="!show" title="menu"></a>
            <div :class="{ 'z-depth-2': show }" v-if="show" @click="toggle">
                <slot v-if="show"></slot>
            </div>
        </div>
        <div class="desktop">
            <slot></slot>
        </div>
    </nav>
</template>
<script lang="ts">
import Vue from 'vue';

export default Vue.defineComponent({
    data: function(){
        return {
            show: false
        };
    },
    methods: {
        toggle: function(){
            this.show = !this.show;
        }
    }
})
</script>